<template>
    <MainContent 
        title='Liquidaciones productos'
    >
        <template v-slot:header>
            <b-button
                size="sm"
                :to="{name: 'back.liquidaciones.productos.crear'}"
                class="mb-3 d-block d-md-inline"
            >
                Solicitar nueva liquidación
            </b-button>
        </template>
        <template v-slot:subheader>
            <FiltersBar @updateLiquidaciones="getLiquidaciones"/>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <div class="row" v-if="liquidaciones">
                    <div class="col-12">
                        <b-table
                            striped
                            hover
                            :items="liquidaciones.data"
                            :fields="fields"
                            empty-text="No se ha encontrado ninguna liquidación"
                            responsive
                            class="table-responsive has-options"
                        >
                            <template #cell(estado)="data">
                                <b-badge pill :variant="getColorEstado(data.value)">{{ data.value | formatear_liquidacion_estado }}</b-badge>
                            </template>
                            <template #cell(importe_total)="data">
                                {{ data.value | formatear_precio }}
                            </template>       
                            <template #cell(opciones)="{ item }">
                                <b-dropdown 
                                    :id="'dropdown-' + item.id" text="Opciones" 
                                    class="m-md-2"
                                >
                                    <b-dropdown-item 
                                        :href="getUrlPdf(item.id)" target="_blank" 
                                    >
                                        Previsualizar en pdf
                                    </b-dropdown-item>
                                    <b-dropdown-item 
                                        v-if="item.estado === 0"
                                        @click="sendForReview(item.id)"
                                    >
                                        Solicitar liquidación
                                    </b-dropdown-item>
                                    <b-dropdown-item 
                                        v-if="item.estado === 0"
                                        @click="showModal('borrar-' + item.id)"
                                    >
                                        Borrar
                                    </b-dropdown-item>
                                </b-dropdown>
                                <BorrarModalComponent
                                    v-if="item.estado === 0"
                                    title="Borrar liquidación"
                                    confirmButton="¿BORRAR  LIQUIDACIÓN?"
                                    :name="'borrar-' + item.id"
                                    @close="() => closeModal(false)"
                                    @confirm="() => borrarLiquidacion(item.id)"
                                />
                            </template>
                        </b-table>

                        <div class="mt-3">
                            <b-pagination
                                v-model="liquidaciones.meta.current_page"
                                :total-rows="liquidaciones.meta.total"
                                :per-page="per_page"
                                align="right"
                                size="sm"
                                @change="getLiquidaciones"
                            />
                        </div>
                    </div>
                </div>
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import FiltersBar from'@/components/backend/liquidaciones/common/FiltersBar.vue';
    import BorrarModalComponent from '@/components/backend/components/BorrarModalComponent.vue';

    export default {
        name: 'LiquidacionesProductos',
        data() {
            return {
                liquidaciones: null,
                per_page: 10,
                fields: ['nombre_evento', 'estado', 'importe_total', 'opciones']
            }
        },
        created() {
            this.getLiquidaciones(1);
        },
        computed: {
            api_key() {
                return this.$store.getters.getUserToken;
            },
            baseUrl() {
                return process.env.VUE_APP_API_BASE;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            getLiquidaciones(page, search = null) {
                const params = {
                    filters : {
                        per_page: this.per_page,
                        page: page
                    }
                };

                if (search) {
                    params.filters.status = search.status;
                    params.filters.fecha = search.fecha;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.productos.index'), params).then(res => {
                    this.liquidaciones = res.data;
                });
            },
            getUrlPdf(liquidacion_id) {
                return `${this.baseUrl}/liquidaciones-productos/${liquidacion_id}/pdf?api_key=${this.api_key}&tid=${this.teatro.hash}`;
            },
            borrarLiquidacion(liquidacion_id) {
                const params = {
                    filters: {},
                    liquidacion_id: liquidacion_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.productos.delete'), params).then(res => {
                    this.$toast.success("Liquidación borrada correctamente");
                    this.closeModal('borrar-' + liquidacion_id, true);
                });
            },
            sendForReview(liquidacion_id) {
                const params = {
                    filters : {},
                    liquidacion_id: liquidacion_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.productos.send-review'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getLiquidaciones(1);
                });
            },
            getColorEstado(estado) {
                switch(estado){
                    case 0 : return 'warning';
                    case 1 : return 'primary';
                    case 2 : return 'success';
                }
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, borrado) {
                this.$modal.hide(modal);
                if(borrado) {
                    this.getLiquidaciones(1);
                }
            }
        },
        components: {
            MainContent,
            ContentOrLoading,
            FiltersBar,
            BorrarModalComponent
        }
    }
</script>

<style scoped>
    .badge {
        padding: 0.75em 2em;
    }
    @media (min-width: 768px) {
        .btn-crear-liquidacion {
            width: auto !important;
        }
    }
</style>